import React, { createContext, useContext, useState, useEffect } from 'react';

type JoinCodeProps = {
  joinCode?: string;
};

const JoinCodeContext = createContext<string | undefined>(undefined);
const JOIN_CODE_ACCESSOR = Symbol.for('nmdp:joinCodeAccessor');

export const JoinCodeContextProvider: React.FC<JoinCodeProps> = ({ children, joinCode }) => {
  const [joinCodeState, setJoinCodeState] = useState<string>();

  useEffect(() => {
    if (typeof window === 'undefined' || !window.localStorage) {
      return;
    }
    if (joinCode) {
      window.localStorage.setItem('joinCodeValue', joinCode);
      if (joinCode !== joinCodeState) {
        setJoinCodeState(joinCode);
        (window as unknown as Record<symbol, unknown>)[JOIN_CODE_ACCESSOR] = joinCode;
      }
    } else {
      const joinCodeStorageValue = window.localStorage.getItem('joinCodeValue');
      if (joinCodeStorageValue && joinCodeStorageValue !== joinCodeState) {
        setJoinCodeState(joinCodeStorageValue);
        (window as unknown as Record<symbol, unknown>)[JOIN_CODE_ACCESSOR] = joinCodeStorageValue;
      }
    }
  }, [joinCode, joinCodeState]);

  return <JoinCodeContext.Provider value={joinCodeState}>{children}</JoinCodeContext.Provider>;
};

export const useJoinCode = () => useContext(JoinCodeContext);
